export const LOCALES = {
  ENGLISH: "en",
  FRENCH: "fr",
  GERMAN: "de",
};

export const DEFAULT_LOCALE = LOCALES.ENGLISH;
